module.exports = __webpack_public_path__ + "img/membership-banner.331947a7.jpg";